import { FC2PropTypes } from './fc2';
import { view, lensPath } from 'ramda';
import { isEnterKey } from '../../utility';

export const ControlPropTypes = {
  placeholder: {
    type: String,
  },
  value: {
    required: true,
  },
  type: {
    type: String,
    default: "string",
  },

  validators: {
    type: Array,
    default: () => []
  },
  cv: {
    type: Array,
    default: () => []
  },
};


export const createValidator = (text, value) => {
  return {
    text,
    value,
  }
}

const requiredValidator = (value) => {
  if (`${value}`.length == 0) {
    return false;
  } else {
    return true;
  }
}


export const INPUT_HEIGHT = 32;
export const TEXTAREA_HEIGHT = 80;

export const FC2Mixin = () => {
  return ({
    props: {
      ...FC2PropTypes,
      ...ControlPropTypes,
    },
    data: function () {
      return {

      };
    },
    computed: {
      idC: function () {
        return this.id ? this.id : `${toSnakeCase(this.label)}_${_id}`;
      },
      valued: function () {
        return this.value ? true : false;
      },
    },
    methods: {
      emit: function (name, event, valuePath = ['target', 'value']) {
        let value = view(lensPath(valuePath))(event);
        const control = event?.target;
        const validity = event?.target?.validity;

        if (name == 'blur' || name == 'change') {
          if (this.type == 'percent' || this.type == 'number') {
            if (validity) {
              if (validity.patternMismatch) {
                control.setCustomValidity('Please enter a valid Number');
                control.reportValidity();

                return;
              } else {
                control.setCustomValidity('');
                control.reportValidity();
              }
            }
            if (value?.length > 0 && value?.includes(',')) {
              value = value.replace(',', '.');
            }
          } else {
            this.validateInput?.(value, control);
          }
        }

        if (name == 'keyup' && isEnterKey(event)) {
          this.$emit('enter', {
            name: this.id,
            // event,
            value,
          });
        } else {
          this.$emit(name, {
            name: this.id,
            event,
            value,
          });
        }

      },
    },
  })
}